import React from "react";
import styles from "./DashboardSkeleton.module.css";

const DashboardSkeleton = () => {
  return (
    <main className="main">
      <div className="content">
        {/* Marquee Loader */}
        <div className="row mb-2">
          <div className="col-12">
            <div className={`${styles.shimmer} ${styles.marqueeLoader}`}></div>
          </div>
        </div>

        {/* Header Section */}
        <div className="row mb-2 align-items-center">
          <div className="col-md-6 col-12">
            <div className={styles.greetingBox}>
              <div
                className={`${styles.shimmer} ${styles.circle} ${styles.avatar}`}
              ></div>
              <div className={`${styles.shimmer} ${styles.textLine}`}></div>
            </div>
          </div>
          <div className={`col-md-6 col-12 ${styles.buttonGroup} mt-2 mt-md-0`}>
            <div
              className={`${styles.shimmer} ${styles.pill} ${styles.btnLoader}`}
            ></div>
            <div
              className={`${styles.shimmer} ${styles.pill} ${styles.btnLoader}`}
            ></div>
            <div
              className={`${styles.shimmer} ${styles.pill} ${styles.btnLoader}`}
            ></div>
            <div
              className={`${styles.shimmer} ${styles.pill} ${styles.btnLoader}`}
            ></div>
          </div>
        </div>

        {/* Content Grid */}
        <div className="row gy-3 mb-6">
          <div className="col-12">
            <div className={`${styles.shimmer} ${styles.bannerLoader}`}></div>
          </div>
          <div className="col-12">
            <div
              className={`${styles.shimmer}`}
              style={{ height: "80px", width: "100%" }}
            ></div>
          </div>

          {/* Business, Commision, Rank Placeholders */}
          {[1, 2, 3].map((i) => (
            <div key={i} className="col-md-4">
              <div className={`${styles.shimmer} ${styles.cardLoader}`}></div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default DashboardSkeleton;
